import { ThemeOptions } from "@mui/material";

const shape: ThemeOptions["shape"] = { borderRadius: 16 };

export default shape;
